import React, { useEffect, useRef, useState } from 'react';
import classes from './MediaImageFromLink.module.scss';
import classNames from 'classnames';
import mediaItemClasses from '../MediaItem/MediaItem.module.scss';
import { CheckboxWithAction } from '../../../components/actions/CheckboxWithAction';
import { MediaImageFromLinkViewProps } from './MediaImageFromLink.view';
import { useNativeImageSize } from '../../../hooks/useNativeImageSize';

export type MediaItemFromLinkProps = {
  index: number;
  loading: boolean;
  url: string;
  checked: boolean;
  selectHandler: MediaImageFromLinkViewProps['selectHandler'];
};
export const MediaItemFromLink = (props: MediaItemFromLinkProps): JSX.Element => {
  const { index, loading, url, checked, selectHandler } = props;
  const [imageClasses, setImageClasses] = useState<string>(mediaItemClasses.ImageWrapper);

  const imageRef = useRef<HTMLImageElement | null>(null);

  const { width: imgWidth, height: imgHeight } = useNativeImageSize(imageRef);

  useEffect(() => {
    if (imgWidth && imgHeight && imgWidth < 96 && imgHeight < 96) {
      setImageClasses(classNames(mediaItemClasses.ImageWrapper, mediaItemClasses.ImageWrapperSmall));
    } else {
      setImageClasses(mediaItemClasses.ImageWrapper);
    }
  }, [imgWidth, imgHeight]);

  return (
    <div className={classes.ItemWrapperSmall} key={index}>
      <div
        className={classNames(mediaItemClasses.MediaItem, classes.NoHover, {
          [mediaItemClasses.MediaItemLoading]: loading
        })}>
        <div className={imageClasses}>
          <img ref={imageRef} src={url} alt={`preview-${index}`} />
        </div>
        <div className={classes.CheckboxWrapper}>
          <CheckboxWithAction
            name={`image-${index}`}
            size={'large'}
            checked={checked}
            onClickHandler={e => selectHandler(index, e)}
          />
        </div>
      </div>
    </div>
  );
};
